export default __webpack_public_path__ + "./img/soundDisabled.514139b5213f02bc687e266da9bbe615.png";